import { render, staticRenderFns } from "./main_form.vue?vue&type=template&id=1fb1f1f3&scoped=true"
import script from "./main_form?vue&type=script&lang=js&external"
export * from "./main_form?vue&type=script&lang=js&external"
import style0 from "./main_form.vue?vue&type=style&index=0&id=1fb1f1f3&prod&lang=css"
import style1 from "./main_form.vue?vue&type=style&index=1&id=1fb1f1f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1f1f3",
  null
  
)

export default component.exports